export default "__VITE_ASSET__D0QFBx1Y__"